import { IconProps } from "./IconProps";

const CopyIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = "#0F5051",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 17" fill="none">
      <path
        d="M4.81165 13.4701C4.3734 13.4701 3.99824 13.3126 3.68615 12.9976C3.37406 12.6826 3.21802 12.3039 3.21802 11.8616V2.21013C3.21802 1.76778 3.37406 1.38909 3.68615 1.07408C3.99824 0.759068 4.3734 0.601562 4.81165 0.601562H11.983C12.4212 0.601562 12.7964 0.759068 13.1085 1.07408C13.4206 1.38909 13.5766 1.76778 13.5766 2.21013V11.8616C13.5766 12.3039 13.4206 12.6826 13.1085 12.9976C12.7964 13.3126 12.4212 13.4701 11.983 13.4701H4.81165ZM1.62439 16.6873C1.18614 16.6873 0.810976 16.5298 0.49889 16.2147C0.186805 15.8997 0.0307617 15.521 0.0307617 15.0787V3.8187H1.62439V15.0787H10.3894V16.6873H1.62439Z"
        fill={color}
      />
    </svg>
  );
};
export default CopyIcon;
